import gql from 'graphql-tag';

export const GET_TRANSACTION_VOLUME = gql`
  query TransactionVolume($params: ReportInput!) {
    transactionSummary(params: $params) {
      result {
        transactionDate
        totalTransactionAmount
        cashbackAmount
      }

      timeslice
    }
  }
`;

export default GET_TRANSACTION_VOLUME;
